(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amgo-super-ring-details"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('amgo-super-ring')) return;
  customElements.define('amgo-super-ring', class extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      const signal = this._abort.signal;
      this.slides = [...this.querySelectorAll('[data-sr-slide]')];
      this.selectors = [...this.querySelectorAll('[data-sr-select]')];
      this.index = 0;
      if (!this.slides.length) return;
      this.addEventListener('click', (event) => {
        const select = event.target.closest('[data-sr-select]');
        if (select && this.contains(select)) this.show(Number(select.dataset.srSelect), true);
        const arrow = event.target.closest('[data-sr-step]');
        if (arrow && this.contains(arrow)) this.show(this.index + Number(arrow.dataset.srStep), true);
      }, {signal});
      const gallery = this.querySelector('[data-sr-gallery]');
      let start;
      gallery?.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) { start = null; return; }
        start = {x:event.touches[0].clientX,y:event.touches[0].clientY};
      }, {passive:true,signal});
      gallery?.addEventListener('touchend', (event) => {
        if (!start || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)*1.4) this.show(this.index + (dx<0?1:-1),true);
        start = null;
      }, {passive:true,signal});
      this.addEventListener('shopify:block:select',(event)=>{
        const i=this.slides.findIndex(slide=>slide.dataset.blockId===String(event.detail?.blockId));
        if(i>=0)this.show(i,false);
      },{signal});
      this.show(0,false);
    }
    disconnectedCallback(){this._abort?.abort();this._abort=null;}
    show(index,announce){
      const length=this.slides.length;
      this.index=(index+length)%length;
      this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index;});
      this.selectors.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===this.index)));
      const slide=this.slides[this.index];
      this.querySelector('[data-sr-caption]').textContent=slide.dataset.caption||'';
      this.querySelector('[data-sr-count]').textContent=String(this.index+1).padStart(2,'0')+' / '+String(length).padStart(2,'0');
      if(announce)this.querySelector('[data-sr-status]').textContent='Detail '+(this.index+1)+' of '+length+': '+(slide.dataset.caption||'');
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
